import { ButtonClose } from '@services/MarppleShop/renderApp/components/atoms/ButtonClose/ButtonClose.ts';
import { $, CustomEventWithDetail, html, View } from 'rune-ts';
import klass from './CreatorLogoSearch.module.scss';
import { CreatorProfile } from './CreatorProfile.ts';

export class CreatorSearchStatusChange extends CustomEventWithDetail<{ status: 'enable' | 'disable' }> {}

export class CreatorLogoSearch extends View<{ profile_url?: string | null }> {
  #status: 'enable' | 'disable' = 'enable';

  override template() {
    const { profile_url } = this.data;

    return html`<button type="button" class="${klass.container}" data-status="${this.#status}">
      ${new CreatorProfile({ profile_url, size: 'small' })} ${new ButtonClose({ tag: 'span' })}
    </button>`;
  }

  override onRender() {
    this.delegate('click', ButtonClose, (e) => {
      // 사용처에서 ButtonClose 를 선택자로 이벤트 핸들러를 등록한 경우 처리되지 않게 하기 위해
      e.originalEvent.preventDefault();
      e.originalEvent.stopImmediatePropagation();
      this.changeStatus();
      this.dispatchEvent(CreatorSearchStatusChange, { bubbles: true, detail: { status: this.#status } });
    });
  }

  changeStatus(status?: 'enable' | 'disable') {
    this.#status = status ?? this.#getReverseStatus();
    $(this.element()).setAttribute('data-status', this.#status);
  }

  #getReverseStatus() {
    if (this.#status === 'enable') return 'disable';
    return 'enable';
  }

  toggleTransparent(on: boolean) {
    const profile = this.subView(CreatorProfile);
    if (!profile) return;
    profile.toggleTransparent(on);
  }
}
